import { render, staticRenderFns } from "./XmarkLight.vue?vue&type=template&id=90a2735e"
import script from "./XmarkLight.vue?vue&type=script&lang=ts"
export * from "./XmarkLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports